import { render, staticRenderFns } from "./NavKuro.vue?vue&type=template&id=0f2033ae"
import script from "./NavKuro.vue?vue&type=script&lang=js"
export * from "./NavKuro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports